/* eslint-disable react/prop-types */
import React from 'react';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

export const ProductSkeleton = () => {
  return (
    <Skeleton data-testid="minipip-product-skeleton" SkeletonContentProps={{ grow: true }}>
      <SkeletonBlock aspect="wide" height={100} />
      <SkeletonLine variant="multi" numberOfLines={8} fullWidth />
    </Skeleton>
  );
};
